import { toRefs, inject, computed } from 'vue';
import kebabCase from 'lodash/kebabCase';

//

/**
 * An accessible tab component.
 */
var script = {
  name: 'Tab',
  props: {
    /**
     * The value of this tab.  When this matches the value
     * value passed to the `<Tabs>` component, this tab
     * will be selected
     */
    value: String,
    disabled: Boolean
  },
  setup(props) {
    const {
      value
    } = toRefs(props);
    const {
      selectedTab
    } = inject('tabs');
    const isActive = computed(() => {
      return value.value === selectedTab.value;
    });
    const classes = computed(() => {
      return {
        'v-tab--active': isActive.value
      };
    });
    function handleClick() {
      selectedTab.value = value.value;
    }
    return {
      handleClick,
      classes,
      isActive,
      kebabCase
    };
  }
};
export { script as default };